<template>
  <div class="page">
    <v-container fluid>
      <v-form ref="form" @submit.prevent="buscarEventoCalendario">
        <v-row class="d-flex justify-center mt-3">
          <v-col cols="4">
            <v-text-field
              label="Evento do Calendário"
              v-model="form.filters.nome"
              outlined
              dense
              maxlength="70"
              hide-details
            ></v-text-field>
          </v-col>
          <sca-select-ativo
            :cols="3"
            :config="{ labelAtivo: 'Sim', labelInativo: 'Não', label: 'Dia Letivo' }"
            v-model="form.filters.diaLetivo"
          ></sca-select-ativo>
          <sca-select-ativo
            :cols="3"
            :config="{ labelAtivo: 'Ativo', labelInativo: 'Inativo', label: 'Situação' }"
            v-model="form.filters.ativo"
          ></sca-select-ativo>
        </v-row>
        <div class="text-center">
          <v-col cols="12">
            <sca-submit-button></sca-submit-button>
            <sca-tooltip
              :text="'Limpar'"
              :icon="'mdi-eraser'"
              @click="resetForm()"
            ></sca-tooltip>
            <sca-tooltip
              :text="'Incluir'"
              :icon="'mdi-plus'"
              @click="openDialogManterEventoCalendario()"
            ></sca-tooltip>
          </v-col>
        </div>
      </v-form>
      <v-data-table
        class="mt-5"
        :headers="table.headers"
        :items="table.itens"
        :items-per-page="10"
        :footer-props="$footerProps"
        :no-data-text="noDataText"
      >
        <template v-slot:[`item.diaLetivo`]="{ item }">
          {{ item.diaLetivo ? 'Sim' : 'Não' }}
        </template>
        <template v-slot:[`item.ativo`]="{ item }">
          <sca-label-ativo :ativo="item.ativo" :config="{ labelAtivo: 'Ativo', labelInativo: 'Inativo' }"></sca-label-ativo>
        </template>
        <template v-slot:[`item.acoes`]="{ item }">
          <sca-tooltip
            :text="'Visualizar'"
            :icon="'mdi-eye-outline'"
            :small="true"
            @click="openDialogVisualizarEventoCalendario(item)"
          ></sca-tooltip>
          <sca-tooltip
            :text="'Editar'"
            :icon="'mdi-pencil'"
            :small="true"
            @click="openDialogManterEventoCalendario(item)"
          ></sca-tooltip>
          <sca-tooltip
            :text="`${item.ativo ? 'Inativar' : 'Ativar'}`"
            :icon="`${item.ativo ? 'mdi-toggle-switch' : 'mdi-toggle-switch-off'}`"
            :small="true"
            @click="inativarAtivarEventoCalendario(item)"
          ></sca-tooltip>
        </template>
      </v-data-table>
    </v-container>
    <CadastrarEditarEventoCalendarioDialog
      :visible="dialogManterEventoCalendario.visible"
      :content="dialogManterEventoCalendario.content"
      :edit="dialogManterEventoCalendario.edit"
      @onClose="dialogManterEventoCalendario.close()"
      @onSave="buscarEventoCalendario()"
    ></CadastrarEditarEventoCalendarioDialog>
    <VisualizarEventoCalendarioDialog
      v-if="dialogVisualizarEventoCalendario.visible"
      :visible="dialogVisualizarEventoCalendario.visible"
      :content="dialogVisualizarEventoCalendario.content"
      @onClose="dialogVisualizarEventoCalendario.close()"
    ></VisualizarEventoCalendarioDialog>
  </div>
</template>

<script>
import { Dialog } from '~/commons/classes/dialog';
import { EventoCalendario } from '~/commons/classes/evento-calendario';
import EventoCalendarioService from '~/services/evento-calendario.service';
import datatablesMixin from '~/mixins/datatables.mixin';
import CadastrarEditarEventoCalendarioDialog from "./dialogs/CadastrarEditarEventoCalendarioDialog.vue";
import VisualizarEventoCalendarioDialog from "./dialogs/VisualizarEventoCalendarioDialog.vue";

export default {
  name: "ManterEventoCalendarioView",
  mixins: [EventoCalendarioService, datatablesMixin],
  components: {
    CadastrarEditarEventoCalendarioDialog,
    VisualizarEventoCalendarioDialog,
  },
  data: () => ({
    dialogManterEventoCalendario: Dialog.Build(),
    dialogVisualizarEventoCalendario: Dialog.Build(),
    form: {
      filters: {
        nome: null,
        diaLetivo: null,
        ativo: null,
      },
      isLoading: false,
      expanded: [],
    },
    table: {
      headers: [
        { text: 'Evento do Calendário', align: 'left', value: 'nome' },
        { text: 'Dia Letivo', align: 'center', value: 'diaLetivo' },
        { text: 'Situação', align: 'center', value: 'ativo', sortable: false },
        { text: 'Ações', align: 'center', value: 'acoes', sortable: false },
      ],
      itens: [],
    },
  }),
  methods: {
    buscarEventoCalendario() {
      if(this.$validarFormulario()) {
        this.form.isLoading = true;
        this.$buscarEventoCalendarios({ params: this.form.filters })
        .then(({ data }) => (this.table.itens = data.itens))
        .finally(() => this.form.isLoading = false);
      }
    },
    openDialogManterEventoCalendario(eventocalendario) {
      eventocalendario
        ? this.$visualizarEventoCalendario(eventocalendario).then(
          ({ data }) => this.dialogManterEventoCalendario.open(new EventoCalendario(data.resposta), true))
        : this.dialogManterEventoCalendario.open(EventoCalendario.Build());
    },
    openDialogVisualizarEventoCalendario(eventocalendario) {
      this.$visualizarEventoCalendario(eventocalendario).then(
        ({ data }) => this.dialogVisualizarEventoCalendario.open(new EventoCalendario(data.resposta)));
    },
    inativarAtivarEventoCalendario(eventocalendario) {
      this.$swal({
        text: `Deseja ${eventocalendario.ativo ? "inativar" : "ativar"} o registro?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonText: `Confirmar`,
        cancelButtonText: `Cancelar`,
      }).then(() => {
        this.$inativarAtivarEventoCalendario(eventocalendario.id).then(({ data }) => {
          this.$notifySuccess(data.mensagem);
          this.buscarEventoCalendario();
        });
      });
    },
    resetForm() {
      this.table.itens = [];
      this.$clearFilters(this.form.filters);
    },
  },
};
</script>
